<template>
  <audio-player
      ref="audioPlayer"
      :is-loop="false"
      :audio-list="[file]"
      :show-prev-button="false"
      :show-next-button="false"
      :show-playback-rate="false"
      :show-volume-button="false"
      theme-color="#7260ff"
  >
    <template #play-start>
      <Pause pause />
    </template>
    <template #play-pause>
      <Pause />
    </template>
  </audio-player>
</template>
<script>
import Pause from '@/components/icons/Pause2'
import AudioPlayer from '@liripeng/vue-audio-player'

export default {
  name: 'vuetify-audio',
  components: {
    Pause,
    AudioPlayer
  },
  props: {
    file: {
      type: String,
      default: null
    }
  },
  beforeDestroy () {
    this.$refs.audioPlayer.pause()
  }
}
</script>
<style lang="scss" scoped>
.audio-player {
  display: flex;
  flex-direction: column;
  ::v-deep.audio__current-time,
  ::v-deep.audio__duration {
    font-size: 12px;
    color: #fff;
  }
  ::v-deep.audio__btn-wrap {
    height: 50px;
  }
  ::v-deep.audio__play-start svg,
  ::v-deep.audio__play-pause svg {
    height: 50px;
  }
  ::v-deep.audio__progress-point {
    width: 20px;
    height: 20px;
    margin-top: -10px;
  }
  ::v-deep.audio__progress-wrap {
    height: 6px;
  }
}
</style>